/* Angular Component */
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ExternalMAMGatewayProviderInfo } from "app/js/src/domain/external-mam/external-mam-gateway-provider-info";
import { ExternalMAMServiceProvider } from "app/js/src/domain/external-mam/external-mam-service-provider";
import { IExternalMAMRepository } from "app/js/src/domain/external-mam/i-external-mam.repository";
import { UserService } from "app/js/src/domain/user-service";
@Component({
  selector: "external-mam-providers-layout",
  templateUrl: "./external-mam-providers-layout.component.html",
  styleUrls: ["./external-mam-providers-layout.component.scss"],
})
export class ExternalMAMProvidersLayoutComponent {
  serviceProviders: ExternalMAMServiceProvider[] = [];
  gatewayProviders: ExternalMAMGatewayProviderInfo[] = [];
  isExternalMAMEditor: boolean = false;
  constructor(
    private _repository: IExternalMAMRepository,
    private router: Router,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    const currentUser = this.userService.getCurrentUser();
    this.isExternalMAMEditor = currentUser.hasEditExternalMAMPermissions;
    this.serviceProviders = await this._repository.loadServiceProviders();
    this.gatewayProviders = await this._repository.loadGatewayProviders();
  }
  goToSearch(pid: string) {
    this.router.navigate([`/external-mam/search/${pid}`]);
  }
  goToEdit(sid: number, pid: string) {
    var name = this.serviceProviders.find((x) => x.id == sid).name;
    this.router.navigate([
      `/external-mam/edit/${ExternalMAMServiceProvider.urlName(name)}/${pid}`,
    ]);
  }
  goToSetup(sid: number) {
    var name = this.serviceProviders.find((x) => x.id == sid).name;
    this.router.navigate([
      "/external-mam/setup/" + ExternalMAMServiceProvider.urlName(name),
    ]);
  }
  getServiceById(sid: number) {
    return this.serviceProviders.find((x) => x.id == sid);
  }
}
